<template>
  <div>
    <div class="l-container">
      <div style="display: flex; align-items: center; padding: 5px 0">
        <h1 class="m-name">[{{tutor.id}}] {{tutor.f_name}} {{tutor.l_name}}({{tutor.f_name_kana}} {{tutor.l_name_kana}}) 様</h1>

        <div class="mediumForm">

          <ul>
            <li class="medium-list" v-for="(list, index) in tutor.tutor_channels" :key="index">

              <template v-if="list.channel">
                <span>{{list.channel.name}}</span>
              </template>

            </li>
          </ul>

        </div>

      </div>


      <section-navi>
        <section-item>
          <router-link :to="{ name: 'tutorindex', params: { id: tutor.id }, exact: true }" exact>データ</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'tutormedium', params: { id: tutor.id }, exact: true }">媒体</router-link>
        </section-item>
        <section-item @click.native="getGeo">
          <router-link :to="{ name: 'tutormap', params: { id: tutor.id }, exact: true }">地図</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'tutorhistory', params: { id: tutor.id }, exact: true }">対応履歴</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'tutorfileview', params: { id: tutor.id }, exact: true }">先生ファイル</router-link>
        </section-item>
        <!-- <section&#45;item> -->
        <!--   <router&#45;link :to="{ name: 'tutorreports', params: { id: tutor.id }, exact: true }">指導報告書(メンテ中)</router&#45;link> -->
        <!-- </section&#45;item> -->
        <!-- <section&#45;item> -->
        <!--   <router&#45;link :to="{ name: 'tutoragreements', params: { id: student.id }, exact: true }">生徒契約内容</router&#45;link> -->
        <!-- </section&#45;item> -->
        <!-- <section&#45;item> -->
        <!--   <router&#45;link :to="{ name: 'tutorimg', params: { id: tutor.id }, exact: true }">img</router&#45;link> -->
        <!-- </section&#45;item> -->
        <section-item>
          <tutor-modal :tutor="tutor"></tutor-modal>
        </section-item>
      </section-navi>
      <router-view :tutor="tutor" :condition="condition" :edit_id="edit_id"></router-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      edit_id: {
        tutor_id: '',
        list_id: ''
      },
      condition: {
        condition: false
      },

      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },
  computed: {
    tutor () {
      return this.$store.getters.tutor
    },
    param () {
      return this.$route.params
    }
  },
  methods: {
    getGeo () {
      this.$store.dispatch('getGeo', {
        this: this,
        tutor: this.tutor,
        pref: this.pref
      })
    },

    getTutor (id) {
      Vue.delete(this.tutor, 'tutorsupports')
      Vue.delete(this.tutor, 'student_tutors')
      Vue.delete(this.tutor, 'tutor_channels')
      this.$store.dispatch('getTutor', id)
    },

    getStudents (id) {
      this.$store.dispatch('getStudents', id)
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getChannels (id) {
      this.$store.dispatch('getChannels', id)
    },

    getOffice_channels () {
      this.$store.dispatch('getOffice_channels')
    },

    getPrefs (id) {
      this.$store.dispatch('getPrefs', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutor(to.params.id)
      vm.getStudents(to.params.id)
      vm.getTags(to)
      vm.getChannels(to.params.id)
      vm.getOffice_channels()
      vm.getPrefs(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.mediumForm {
  display: flex;
  align-items: center;
  ul {
    margin: 0;
    display: flex;
    white-space: nowrap;
    .medium-list {
      display: flex;
      list-style: none;
      margin-left: 5px;
      background: #41B883;
      color: #fff;
      border-radius: 20px;
      span {
        padding: 10px;
        width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Tutor.vue?526ff5f9